<template>
  <transition name="scale">
    <v-progress-circular
      class="mx-auto"
      :size="50"
      color="primary"
      indeterminate
    ></v-progress-circular>
  </transition>
</template>

<script>
export default {
  name: 'Loader'
}
</script>
